<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Preferences" styleClass="user-settings-tab-panel">
    <bfx-order-blotter-settings-preferences #subComponent> </bfx-order-blotter-settings-preferences>
  </p-tabPanel>

  <p-tabPanel header="Temperature" styleClass="user-settings-tab-panel">
    <bfx-order-blotter-settings-temperature #subComponent> </bfx-order-blotter-settings-temperature>
  </p-tabPanel>
</p-tabView>
